import { Button, type ButtonProps } from "@/components/ui/button"
import { Spinner } from "@/components/ui/spinner"
import * as React from "react"

interface PendingButtonProps extends ButtonProps {
  /** The API call this button started is running: show the spinner and
   *  block clicks, but keep the label as it is. */
  pending: boolean
  /** Leading icon; the spinner takes its place while pending. */
  icon?: React.ReactNode
}

/** A button that calls an API. */
export const PendingButton = React.forwardRef<
  HTMLButtonElement,
  PendingButtonProps
>(({ pending, icon, disabled, children, ...props }, ref) => (
  <Button ref={ref} disabled={disabled || pending} {...props}>
    {pending ? <Spinner /> : icon}
    {children}
  </Button>
))
PendingButton.displayName = "PendingButton"
